import React, { useMemo } from 'react';
import countries from 'i18n-iso-countries';
import { Selectbox } from '@01_people/ui-library';
import CountrySelectSC from './country-select.styled';

const ALL_LANGUAGES = Object.keys(countries.getAlpha2Codes());

const CountrySelect = ({
  value,
  defaultValue,
  countryCodes,
  customClass,
  placeholder,
  onChange,
  onBlur,
  errors,
  noOptionsMessage,
  required = false,
  disabled = false,
  language = 'en'
}) => {
  const countryOptions = useMemo(() => {
    try {
      countries.registerLocale(
        require(`i18n-iso-countries/langs/${language}.json`)
      );
    } catch (error) {
      countries.registerLocale(require(`i18n-iso-countries/langs/en.json`));
    }

    if (countryCodes) {
      return countryCodes.map(code => {
        return {
          label: countries.getName(code, language),
          value: code
        };
      });
    }

    return ALL_LANGUAGES.map(code => {
      return {
        label: countries.getName(code, language),
        value: code
      };
    });
  }, [countryCodes, language]);

  const getSelectedOption = useMemo(
    () => countryOptions.find(country => country.value === value),
    [value, countryOptions]
  );

  const getDefaultValueOption = useMemo(
    () => countryOptions.find(country => country.value === defaultValue),
    [countryOptions, defaultValue]
  );

  return (
    <CountrySelectSC>
      <Selectbox
        value={getSelectedOption}
        customClass={customClass}
        required={required}
        defaultValue={getDefaultValueOption}
        options={countryOptions}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        noOptionsMessage={noOptionsMessage}
      />
      <div className="errors">
        {errors.map(err => (
          <p className="errors-element">{err}</p>
        ))}
      </div>
    </CountrySelectSC>
  );
};

export default CountrySelect;
